import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function AgeCriteria() { 
  useEffect(() => {
    document.title = 'Age Criteria-  CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li> 
                <li>Admission</li>
                <li>Age Criteria</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Age Criteria</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12"> 
               <h5>Age Criteria: For 2025-2026</h5>
               <div class="table-responsive maintable">
               <table class="table"> 
                   <tbody>
                         <tr>
                           <td>NURSERY </td>
                           <td>1st April 2021 - 31st March 2022 </td>
                           </tr> 
                           <tr>
                           <td>L.KG </td>
                           <td>1st April 2020 - 31st March 2021 </td>
                           </tr> 
                           <tr>
                           <td>U.KG </td>
                           <td>1st April 2019 - 31st March 2020 </td>
                           </tr> 
                           <tr>
                           <td>GRADE I </td>
                           <td>1st April 2018 - 31st March 2019 </td>
                           </tr> 
                           <tr>
                           <td>GRADE II </td>
                           <td>1st April 2017 - 31st March 2018 </td>
                           </tr> 
                           <tr>
                           <td>GRADE III </td>
                           <td>1st April 2016 - 31st March 2017 </td>
                           </tr> 
                           <tr>
                           <td>GRADE IV </td>
                           <td>1st April 2015 - 31st March 2016 </td>
                           </tr> 
                           <tr>
                           <td>GRADE V </td>
                           <td>1st April 2014 - 31st March 2015 </td>
                           </tr>
                   </tbody> 
               </table>
               </div>
              
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AgeCriteria;
